<template>
  <v-container fluid>
    <PageTitle title="Roles" />

    <ApiDataTable
      data-api="roles"
      :can-insert="true"
      :can-update="true"
      :can-delete="true"
      :row-buttons="[{ title: 'Resources', icon: 'mdi-shield-edit-outline' }]"
      @row-button-click="editResource"
    />

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>Edit {{ role.name }} resources</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 500px" class="pa-0">
          <v-tabs fixed-tabs v-model="tab">
            <v-tab v-for="type in types" :key="type">{{ type }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="type in types" :key="type">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Resource Name</th>
                    <th v-if="type == 'workflow'">Run</th>
                    <th v-else-if="type == 'table'">Read</th>
                    <th v-else-if="type == 'main_menu' || type == 'side_menu'">
                      Visible
                    </th>
                    <th v-if="type == 'table'">Insert</th>
                    <th v-if="type == 'table'">Update</th>
                    <th v-if="type == 'table'">Delete</th>
                    <th v-if="type == 'service'">Enable</th>
                    <th style="width: 110px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in getResources(type)" :key="index">
                    <td>{{ item.resourceName }}</td>
                    <td>
                      <v-checkbox
                        hide-details
                        v-model="item.canRead"
                        :disabled="editIndex != index"
                        class="ma-0"
                      ></v-checkbox>
                    </td>
                    <td v-if="type == 'table'">
                      <v-checkbox
                        hide-details
                        v-model="item.canInsert"
                        :disabled="editIndex != index"
                        class="ma-0"
                      ></v-checkbox>
                    </td>
                    <td v-if="type == 'table'">
                      <v-checkbox
                        hide-details
                        v-model="item.canUpdate"
                        :disabled="editIndex != index"
                        class="ma-0"
                      ></v-checkbox>
                    </td>
                    <td v-if="type == 'table'">
                      <v-checkbox
                        hide-details
                        v-model="item.canDelete"
                        :disabled="editIndex != index"
                        class="ma-0"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-btn
                        v-if="editIndex != index"
                        @click="edit(item, index)"
                        color="primary"
                        icon
                        :disabled="editIndex != index && editIndex > -1"
                        title="Edit"
                      >
                        <v-icon>mdi-square-edit-outline</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="editIndex == index"
                        @click="save"
                        color="primary"
                        icon
                        title="Save"
                      >
                        <v-icon>mdi-content-save-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="enableAll">Enable All</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import server from "../../services/server";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Roles",

  components: { ApiDataTable, PageTitle },

  data() {
    return {
      dialog: false,
      role: {},
      resources: [],
      tab: 0,
      types: ["table", "workflow", "main_menu", "side_menu", "service"],
      loading: false,
      editIndex: -1,
      editItem: null,
    };
  },

  methods: {
    async enableAll() {
      if (confirm("Do you want to enable all access for this role?")) {
        this.loading = true;
        var type = this.types[this.tab];
        var resources = this.getResources(type);

        for (let i = 0; i < resources.length; i++) {
          const r = resources[i];
          r.canRead = true;
          r.canInsert = true;
          r.canUpdate = true;
          r.canDelete = true;
          await server.post("roles/" + this.role.roleId + "/resources", r);
        }

        this.loading = false;
      }
    },
    editResource({ item }) {
      this.role = item;
      this.dialog = true;
      this.loading = true;

      server.get("roles/" + item.roleId + "/resources").then((response) => {
        this.loading = false;
        this.resources = response;
      });
    },
    getResources(type) {
      return this.resources.filter((f) => f.resourceType == type);
    },
    edit(item, index) {
      this.editItem = item;
      this.editIndex = index;
    },
    save() {
      this.loading = true;

      server
        .post("roles/" + this.role.roleId + "/resources", this.editItem)
        .then(() => {
          this.loading = false;
          this.editIndex = -1;
        })
        .catch((err) => {
          this.loading = false;
          alert(err);
        });
    },
  },
};
</script>
